import {
  FETCH_COUNTRY,
  FETCH_COUNTRY_ERROR,
  RECEIVE_COUNTRY,
} from "../../actions/CountrySelector";

const initialState = {
  countryFetching: false,
  countryFetched: false,
  isVisible: false,
  premierAvailable: false,
  apiError: false,
};

const CountrySelector = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COUNTRY: {
      return Object.assign({}, state, {
        countryFetching: true,
        apiError: undefined,
      });
    }
    case FETCH_COUNTRY_ERROR: {
      return Object.assign({}, state, {
        apiError: action.apiError,
        countryData: null,
      });
    }
    case RECEIVE_COUNTRY: {
      return Object.assign({}, state, {
        countryFetching: false,
        countryFetched: true,
        countryData: action.countryData,
        premierAvailable: action.premierAvailable,
        apiError: undefined,
      });
    }
    default: {
      return state;
    }
  }
};

export default CountrySelector;
